module.exports = __webpack_public_path__ + "static/media/au-coeur-de-l-actualite-des-consomacteurs-les-strategies-face-a-l-inflation-mini.e7d868a5.png";